module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop1.d185369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop1.jpg
// module id = NokR
// module chunks = 0